import axios from "./axiosWrapper";

/** Falcon success bodies are `{ success, message, data: payload }`; axios `response.data` is that body. */
function unwrapFalconPayload(res) {
    const body = res?.data;
    if (body && typeof body === "object" && "data" in body) {
        return body.data;
    }
    return body;
}

function withUnwrappedData(promise) {
    return promise.then((res) => ({
        ...res,
        data: unwrapFalconPayload(res),
    }));
}

const User = {
    getInstitutions(isCollege, filters) {
        return withUnwrappedData(
            axios.get(
                `/user/list-institutions?profileTypeID=${isCollege ? 1 : 0}${filters ? `&filters=${JSON.stringify(filters)}` : ""}`
            )
        );
    },
    getUserDetails(id) {
        return withUnwrappedData(axios.get(`/user/details/${encodeURIComponent(id)}`));
    },
    getAdminList() {
        return withUnwrappedData(axios.get(`/user/get-admins`));
    },
    addAdmin(data) {
        return withUnwrappedData(axios.post(`/user/add-admin`, data));
    },
    deleteAdmin(id) {
        return withUnwrappedData(axios.delete(`/user/delete-admin/${encodeURIComponent(id)}`));
    },
    updateAdmin(id, data) {
        return withUnwrappedData(axios.put(`/user/update-admin-details/${encodeURIComponent(id)}`, data));
    },
    updateInstitutionStatus(id, status, profileTypeID) {
        console.log(id, status, profileTypeID);
        return withUnwrappedData(axios.put(`/user/update-institution/${encodeURIComponent(id)}`, { status, profileTypeID }));
    },
};

export default User;